export enum FirestoreCollections {
  users = "users",
  emailVerification = "emailVerification",
  plans = "plans",
}

export enum FIRESTORE_USER_SUB_COLLECTIONS {
  savedFilters = "Saved Filters",
  domainSettings = "Domain Settings",
}

export enum Role {
  Buyer = "buyer",
  Seller = "seller",
  VirtualDataRoom = "virtual_data_room",
  Docs = "docs",
  Equity = "equity",
}
